var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 9.7522C20.7729 9.76532 22.0489 9.8698 22.8814 10.7022C23.8333 11.6542 23.8333 13.1862 23.8333 16.2503V17.3336C23.8333 20.3977 23.8333 21.9299 22.8814 22.8817C21.9294 23.8336 20.3974 23.8336 17.3333 23.8336H8.66663C5.60249 23.8336 4.07043 23.8336 3.11853 22.8817C2.16663 21.9299 2.16663 20.3977 2.16663 17.3336V16.2503C2.16663 13.1862 2.16663 11.6542 3.11853 10.7022C3.95094 9.8698 5.22701 9.76532 7.58329 9.7522",
    stroke: "white",
    strokeWidth: 2.21,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.25V2.16663M13 2.16663L16.25 5.95829M13 2.16663L9.75 5.95829",
    stroke: "white",
    strokeWidth: 2.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d74db4abf8669532b4941a5bf2121c2c.svg";
export { ForwardRef as ReactComponent };